import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
var Suggestions = /*#__PURE__*/function (_React$Component) {
  function Suggestions(props) {
    var _this;
    _classCallCheck(this, Suggestions);
    _this = _callSuper(this, Suggestions, [props]);
    _this.bindings = {
      onMouseLeave: _this.onMouseLeave.bind(_this)
    };
    return _this;
  }
  _inherits(Suggestions, _React$Component);
  return _createClass(Suggestions, [{
    key: "onMouseLeave",
    value: function onMouseLeave() {
      this.props.onMouseLeave(null);
    }
  }, {
    key: "render",
    value: function render() {
      var _a;
      if (!((_a = this.props.children) === null || _a === void 0 ? void 0 : _a.length)) {
        return null;
      }
      return /*#__PURE__*/React.createElement("ul", {
        role: "listbox",
        hidden: !this.props.visible,
        onMouseLeave: this.bindings.onMouseLeave
      }, this.props.children);
    }
  }]);
}(React.Component);
Suggestions.defaultProps = {
  children: []
};
export default Suggestions;